import { ITEM_LABEL_TH } from '@/itemSales';

/**
 * Resolve a POS item code to its Thai display name.
 *
 * Precedence: the backend name_th wins — the server is the canonical source
 * for display names (merged adult/kid rows arrive suffix-free, e.g. กุ้งแก้ว);
 * a name_th that merely echoes the item code is treated as missing so the
 * curated map can prettify it; the map also covers responses without
 * name_th; finally the raw code as a last resort.
 */
export function itemDisplayName(item: { item_code: string; name_th?: string }): string {
  const backend = item.name_th?.trim();
  if (backend && backend !== item.item_code) return backend;
  const canonical = ITEM_LABEL_TH[item.item_code]?.name;
  if (canonical) return canonical;
  return item.item_code;
}
